// extracted by mini-css-extract-plugin
export default {"stickyWrapper":"StickyFilters_stickyWrapper__gqDM8"};